var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "warning-sign_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.363 39.509L21.356 5.6a2.983 2.983 0 015.288 0l17.993 33.909A3.046 3.046 0 0141.993 44H6.007a3.046 3.046 0 01-2.644-4.491zM24 16v14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 36,
    r: 1
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+d2FybmluZyBzaWduPC90aXRsZT48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMjcyNzI2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIj48cGF0aCBkPSJNMy4zNjMsMzkuNTA5LDIxLjM1Niw1LjZhMi45ODMsMi45ODMsMCwwLDEsNS4yODgsMEw0NC42MzcsMzkuNTA5QTMuMDQ2LDMuMDQ2LDAsMCwxLDQxLjk5Myw0NEg2LjAwN0EzLjA0NiwzLjA0NiwwLDAsMSwzLjM2MywzOS41MDlaIj48L3BhdGg+PGxpbmUgeDE9IjI0IiB5MT0iMTYiIHgyPSIyNCIgeTI9IjMwIiBzdHJva2U9IiMyNzI3MjYiPjwvbGluZT48Y2lyY2xlIGN4PSIyNCIgY3k9IjM2IiByPSIxIiBzdHJva2U9IiMyNzI3MjYiPjwvY2lyY2xlPjwvZz48L3N2Zz4=";
export { SvgWarningSign as ReactComponent };